import React, {Component} from 'react';

import UserDemographicMap from './../user_demographic_map/';
import ScrollEffect from './../../lib/scroll-effect';

export default class ContentNoLimits extends Component {
    constructor(){
        super();
        this.startUserDemographicMap = this.startUserDemographicMap.bind(this);
        this.displayUserDemographicMap = this.displayUserDemographicMap.bind(this);
    }

    startUserDemographicMap(){
        this.refs.userDemographicMap.start();
    }

    displayUserDemographicMap(){
        const {isMobile, pageWidth} = this.props;
        const mapMobileImg = require('images/branded_content/content_no_limits_mobile.png')

        return isMobile ? (
            <div className='gr-12 content-no-limits-map'>
                <img src={mapMobileImg} />
            </div>
        ) : (
            <div className='gr-12 content-no-limits-map'>
                <ScrollEffect animate="animating" callback={this.startUserDemographicMap} duration={0} />
                <UserDemographicMap
                    ref="userDemographicMap"
                    renderingComponent={'ContentNoLimits'}
                    markerType={"DisplayMarkerSquare"}
                    pageWidth={pageWidth}
                    interval={1000} />
            </div>
        );
    }

    render(){
        const map = this.displayUserDemographicMap();

        return(
            <div className='gr-12 content-no-limits'>
                <div className='gr-12 content-no-limits-text'>
                    <h1>Content with no limits</h1>
                    <p>Activate consumers across the globe to create authentic, regionalized content for all marketing needs.</p>
                </div>
                {map}
                <div className='hide show@xs map-scroll-indicator'></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/branded_content/content_no_limits.js